import React, { useState } from 'react';
import { Modal, PrimaryButton, SecondaryButton } from '@common/components';
import {
  SuppliersManagementTierForm,
  SuppliersManagementTierFormValues,
} from './_suppliers-management-tier-form';
import { FormInstance } from 'antd';
import { createMessage } from 'works/legacy/lib/message-helper';
import { useMutation } from '@common/hooks';
import { CreateTierMutation } from '@institutions/graphql';

type SuppliersManagementCreateTierModalProps = {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  onCreate: (tier_id: string) => void;
};

export function SuppliersManagementCreateTierModal({
  visible,
  setVisible,
  onCreate,
}: SuppliersManagementCreateTierModalProps) {
  const [formInstance, setFormInstance] =
    useState<FormInstance<SuppliersManagementTierFormValues>>();

  const [mutation, { loading }] = useMutation(CreateTierMutation, {
    onCompleted: (data) => {
      if (data.createTier?.tier) {
        onCreate(data.createTier.tier.id);
        createMessage(
          'success',
          `${data.createTier.tier.name} successfully saved`
        );
        setVisible(false);
      } else if (data.createTier?.errors) {
        createMessage('error', data.createTier.errors[0].message);
      }
    },
    onError: () => {
      createMessage('error', 'Failed to perform action. Please try again.');
    },
  });

  const onOk = () => {
    formInstance?.submit();
  };

  const onCancel = () => {
    setVisible(false);
  };

  const onFinish = (values: SuppliersManagementTierFormValues) => {
    mutation({ variables: { input: values } });
  };

  const Footer = (
    <>
      <SecondaryButton key="back" onClick={onCancel} loading={loading}>
        Cancel
      </SecondaryButton>
      <PrimaryButton key="submit" onClick={onOk} loading={loading}>
        Save
      </PrimaryButton>
    </>
  );

  return (
    <Modal
      onOk={onOk}
      onCancel={onCancel}
      visible={visible}
      title="Add Tier"
      footer={Footer}
      destroyOnClose
    >
      <SuppliersManagementTierForm
        onFinish={onFinish}
        onFormInstanceReady={(instance) => {
          setFormInstance(instance);
        }}
      />
    </Modal>
  );
}
